module.exports = __webpack_public_path__ + "img/dang5.c722fdc7.png";